<template>
  <section id="solutions" class="h25-section">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Solutions</div>
        <h2>核心AI内容体系</h2>
        <p>依托自有技术能力、业务场景与存量客户落地案例，打造可推广、可落地的AI数字化内容体系</p>
      </div>
      <div class="ai-block" v-for="block in blocks" :key="block.num">
        <div class="ai-hd"><span class="ai-num">{{ block.num }}</span><h3>{{ block.title }}</h3></div>
        <p class="ai-intro" v-html="block.intro"></p>
        <div class="fn-grid">
          <div class="fn-card" v-for="fn in block.fns" :key="fn.title">
            <h5>{{ fn.title }}</h5>
            <div class="tags"><span v-for="t in fn.tags" :key="t">{{ t }}</span></div>
            <p>{{ fn.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name:'SolutionsSection',
  data(){return{blocks:[
    {num:'01',title:'园区企业通用职能AI',intro:'聚焦园区企业通用经营管理场景，围绕七大核心职能打造轻量化、标准化的AI方案，落地门槛低、普适性强。',fns:[
      {title:'📊 销售管理AI',tags:['客户分层','智能跟进','留存预警'],desc:'AI客户分层+智能跟进提醒+销售话术辅助，降低流失率，转化效率翻倍'},
      {title:'👥 人力/行政AI',tags:['智能考勤','档案归档','公文编撰'],desc:'AI考勤核算+档案自动归档+公文智能编撰，人事行政效率翻倍'},
      {title:'💰 财务管理AI',tags:['票据识别','费用稽核','风险预警'],desc:'AI票据识别+费用稽核+账务自动核对，财务合规零差错'},
      {title:'📋 采购管理AI',tags:['流程规范','供应商评级','采购管控'],desc:'采购流程智能规范+供应商评级管控+成本分析，供应链透明可控'},
      {title:'📐 项目管理AI',tags:['进度管控','节点预警','资源调配'],desc:'项目节点智能预警+资源调配+看板管理，确保交付不延期'},
      {title:'📦 库存管理AI',tags:['智能盘点','缺货预警','仓储风控'],desc:'库存智能盘点+缺货预警+出入库管理，仓储成本最优化'}
    ]},
    {num:'02',title:'制造业AI',intro:'专注制造业实体经济场景，聚焦<strong>生产安全合规管控、生产效能提质增效</strong>两大核心刚需，专注制造业核心场景。',fns:[
      {title:'🛡️ 生产安全AI管控',tags:['行为监管','隐患预警','高危越界告警'],desc:'行为智能监管+隐患自动预警+越界告警，安全事故率降低90%'},
      {title:'⚡ 生产效率提升AI',tags:['设备监测','排程优化','质检提效'],desc:'设备状态实时监测+排程优化+质检标准化，产线效率提升30%'},
      {title:'📝 工厂台账智能化',tags:['台账自动生成','数据汇总','合规归档'],desc:'台账智能生成+数据自动汇总+异常标注，合规验收一次通过'}
    ]},
    {num:'03',title:'政府业务流程AI',intro:'聚焦政府单位业务流程规范化、高效化、闭环化管理升级，专注政务业务流程优化与政务服务提质增效。',fns:[
      {title:'🔄 政务流程数字化AI',tags:['流程梳理','节点精简','审批提醒','资料归档'],desc:'流程智能梳理+审批提醒+资料自动归档，审批效率提升65%'},
      {title:'📞 政务服务提效AI',tags:['政策拆解','智能应答','堵点研判'],desc:'政策智能拆解+高频咨询应答+堵点研判，服务满意度提升28%'}
    ]}
  ]}}
}
</script>
<style scoped>
.ai-block{margin-bottom:56px}
.ai-hd{margin-bottom:12px;display:flex;align-items:baseline;gap:10px}
.ai-num{font-size:12px;color:var(--h25-muted2);font-weight:600}
.ai-hd h3{font-size:22px;font-weight:700;color:var(--h25-text)}
.ai-intro{font-size:14px;color:var(--h25-muted);margin-bottom:24px;max-width:700px;line-height:1.7}
.fn-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:14px}
.fn-card{background:var(--h25-white);border:1px solid var(--h25-border);border-radius:var(--h25-radius);padding:22px;transition:border-color .2s}
.fn-card:hover{border-color:var(--h25-muted2)}
.fn-card h5{font-size:15px;font-weight:700;color:var(--h25-text);margin-bottom:6px}
.tags{margin-bottom:6px;display:flex;flex-wrap:wrap;gap:4px}
.tags span{font-size:11px;padding:3px 10px;background:var(--h25-bg);color:var(--h25-muted);border-radius:12px;font-weight:500}
.fn-card p{font-size:13px;color:var(--h25-muted);line-height:1.6}
</style>
